import React from "react";

const TextArea = (props) => {
  const { cols, name, onChange, rows, value } = props;

  return (
    <span className={"TextArea " + props.spanClasses}>
      <textarea
        className={"TextArea__input " + props.classes}
        cols={cols || 50}
        disabled={props.disabled}
        id={props.ids}
        name={name}
        onChange={onChange}
        placeholder={props.placeholder || ""}
        rows={rows || 3}
        value={value}
      />
    </span>
  );
};

export default TextArea;
